import { useTranslation } from "react-i18next";
import * as yup from "yup";

export const appl220ValidationSchema = () => {
  const { t } = useTranslation();
  return yup.object().shape({
    d50_id: yup.object().required(t("Το πεδίο είναι υποχρεωτικό")),
    boardDate: yup
      .date()
      .required(t("Το πεδίο είναι υποχρεωτικό"))
      .typeError(t("Το πεδίο πρέπει να είναι ημερομηνία")),
    fudocNotary: yup.string().required(t("Το πεδίο είναι υποχρεωτικό")),
    newCleaners: yup.array().of(
      yup.object().shape({
        fp1Adt: yup.string().when(["ok", "fp1TypeIdDocument"], {
          is: (ok: string, typeIdDocument: any) =>
            ok === "ok" && typeIdDocument?.value === 1,
          then: (schema) =>
            schema
              .required(t("Το πεδίο είναι υποχρεωτικό"))
              .max(20, t("Το πεδίο πρέπει να είναι μέχρι 20 χαρακτήρες")),
          otherwise: (schema) => schema.notRequired(),
        }),
        fp1PassportNumber: yup.string().when(["ok", "fp1TypeIdDocument"], {
          is: (ok: string, typeIdDocument: any) =>
            ok === "ok" && typeIdDocument?.value === 8,
          then: (schema) =>
            schema
              .required(t("Το πεδίο είναι υποχρεωτικό"))
              .max(20, t("Το πεδίο πρέπει να είναι μέχρι 20 χαρακτήρες")),
          otherwise: (schema) => schema.notRequired(),
        }),
        fp2Name: yup.string().when(["ok"], {
          is: (ok: string) => ok === "no",
          then: (schema) => schema.required(t("Το πεδίο είναι υποχρεωτικό")),
        }),
        fp2Surname: yup.string().when(["ok"], {
          is: (ok: string) => ok === "no",
          then: (schema) => schema.required(t("Το πεδίο είναι υποχρεωτικό")),
        }),
        fp2Fathersname: yup.string().when(["ok"], {
          is: (ok: string) => ok === "no",
          then: (schema) => schema.required(t("Το πεδίο είναι υποχρεωτικό")),
        }),
        fp2Doy: yup.object().when(["ok"], {
          is: (ok: string) => ok === "no",
          then: (schema) => schema.required(t("Το πεδίο είναι υποχρεωτικό")),
        }),
        fp2Adt: yup.string().when(["ok", "fp2TypeIdDocument"], {
          is: (ok: string, typeIdDocument: any) =>
            ok === "no" && typeIdDocument && typeIdDocument.value === 8,
          then: (schema) =>
            schema
              .required(t("Το πεδίο είναι υποχρεωτικό"))
              .max(20, t("Το πεδίο πρέπει να είναι μέχρι 20 χαρακτήρες")),
        }),
        fp2PassportNumber: yup.string().when(["ok", "fp2TypeIdDocument"], {
          is: (ok: string, typeIdDocument: any) =>
            ok === "no" && typeIdDocument && typeIdDocument.value === 8,
          then: (schema) =>
            schema
              .required(t("Το πεδίο είναι υποχρεωτικό"))
              .max(20, t("Το πεδίο πρέπει να είναι μέχρι 20 χαρακτήρες")),
        }),
        fp2Odos: yup.string().when(["ok"], {
          is: (ok: string) => ok === "no",
          then: (schema) => schema.required(t("Το πεδίο είναι υποχρεωτικό")),
        }),
        fp2Arithm: yup.string().when(["ok"], {
          is: (ok: string) => ok === "no",
          then: (schema) => schema.required(t("Το πεδίο είναι υποχρεωτικό")),
        }),
        fp2Tk: yup.string().when(["ok"], {
          is: (ok: string) => ok === "no",
          then: (schema) =>
            schema.max(12).required(t("Το πεδίο είναι υποχρεωτικό")),
        }),
        fp2Polh: yup.string().when(["ok"], {
          is: (ok: string) => ok === "no",
          then: (schema) => schema.required(t("Το πεδίο είναι υποχρεωτικό")),
        }),
      }),
    ),
  });
};
